module.exports = __webpack_public_path__ + "img/feature-work-3-large.ae21f7df.jpg";